import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './CookieConsent.module.css';

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

const CONSENT_KEY = 'cookie_consent';

type ConsentValue = 'granted' | 'denied';

const applyConsent = (value: ConsentValue) => {
  if (typeof window.gtag !== 'function') return;

  if (value === 'granted') {
    window.gtag('consent', 'update', {
      analytics_storage: 'granted',
      ad_storage: 'granted',
    });
  } else {
    window.gtag('consent', 'update', {
      analytics_storage: 'denied',
    });
  }
};

const CookieConsent: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(CONSENT_KEY) as ConsentValue | null;

    if (stored === 'granted' || stored === 'denied') {
      applyConsent(stored);
    } else {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    applyConsent('granted');
    localStorage.setItem(CONSENT_KEY, 'granted');
    setVisible(false);
  };

  const handleRefuse = () => {
    applyConsent('denied');
    localStorage.setItem(CONSENT_KEY, 'denied');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={styles.banner} role="dialog" aria-live="polite" aria-label="Consentement aux cookies">
      <div className={styles.container}>
        <div className={styles.textCol}>
          <p className={styles.title}>Cookies</p>
          <p className={styles.text}>
            Nous utilisons des cookies pour mesurer l'audience de Brands 2 Buyers et améliorer votre
            expérience sur le site. Vous pouvez accepter ou refuser leur dépôt à tout moment.{' '}
            <Link to="/mentions-legales" className={styles.link}>
              En savoir plus
            </Link>
          </p>
        </div>
        <div className={styles.actions}>
          <button type="button" className={styles.refuseBtn} onClick={handleRefuse}>
            Refuser
          </button>
          <button type="button" className={styles.acceptBtn} onClick={handleAccept}>
            Accepter
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
